import { render, staticRenderFns } from "./AddToCartStock.vue?vue&type=template&id=cd23c930"
import script from "./AddToCartStock.vue?vue&type=script&lang=ts"
export * from "./AddToCartStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports